import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import cls from '../styles.scss'
import React from 'react'
import { enums } from '@adc/sdk'
import { utils as coreUtils } from '@adc/ui-core'
import { ConfirmingBid, TpsConfirmingBid } from '../costs'
const cx = _cx.bind(cls)

const bidTypeToTextMap = {
  [enums.OnlineAuctionSegmentBidType.Regular]: 'Your Next Bid:',
  [enums.OnlineAuctionSegmentBidType.MaxBid]: 'Your Proxy Bid:',
  [enums.LiveAuctionSegmentBidType.RemoteBid]: 'Your Remote Bid:',
}

const Content = ({
  bidAmount,
  buyersPremium,
  totalPurchasePrice,
  earnestMoneyDeposit,
  usingSellerLevelFees,
  listing,
  segment,
  type,
}) => {
  const bidTypeToContentMap = (isForeclosure = false) => {
    return {
      [enums.OnlineAuctionSegmentBidType.Regular]: isForeclosure ? (
        <TpsConfirmingBid
          bidAmount={bidAmount}
          salesDeposit={listing.trustee?.online_state_deposit_amount}
          segment={segment}
          type={type}
        />
      ) : (
        <ConfirmingBid
          bidAmount={bidAmount}
          buyersPremium={buyersPremium}
          totalPurchasePrice={totalPurchasePrice}
          earnestMoneyDeposit={earnestMoneyDeposit}
        />
      ),
      [enums.LiveAuctionSegmentBidType.RemoteBid]: (
        <TpsConfirmingBid
          bidAmount={bidAmount}
          salesDeposit={listing.trustee?.online_state_deposit_amount}
          segment={segment}
          type={type}
        />
      ),
      [enums.OnlineAuctionSegmentBidType.MaxBid]: <></>,
    }
  }
  return (
    <>
      <div className={cx('bid-pill-container')}>
        <div className={cx('bid-pill')} data-elm-id='amount_to_bid'>
          <span>{bidTypeToTextMap[type]}</span>
          <span>{coreUtils.formatters.formatMoney(bidAmount)}</span>
        </div>
      </div>
      {(usingSellerLevelFees ||
        type === enums.LiveAuctionSegmentBidType.RemoteBid) && (
        <div className={cx('u-mb-3')}>
          {
            bidTypeToContentMap(
              listing.listing_configuration?.asset_type ===
                enums.AssetType.Foreclosure
            )[type]
          }
        </div>
      )}
    </>
  )
}

Content.propTypes = {
  type: PropTypes.string.isRequired,
  bidAmount: PropTypes.number.isRequired,
  usingSellerLevelFees: PropTypes.bool,
  buyersPremium: PropTypes.number.isRequired,
  totalPurchasePrice: PropTypes.number.isRequired,
  earnestMoneyDeposit: PropTypes.number.isRequired,
  listing: PropTypes.object.isRequired,
  segment: PropTypes.object.isRequired,
}
export default Content
